import loadable from '@loadable/component'
import { useLocation } from 'react-router-dom'

import HttpStatus from 'components/Common/HttpStatus'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const HeaderMain = loadable(
  () =>
    import(
      '../../client/components/App/Header/HeaderMain/HeaderMain'
    ),
)

function Trip404Page() {
  const location = useLocation()
  const isTripRoot = !!matchLocaleAwarePath(location.pathname, { path: '/:regionCode/trip-planner/trip', exact: true })

  return (
    <>
      {isTripRoot && (
        <HttpStatus code={404}>
          <HeaderMain />
          <Error404PageWithOffers />
        </HttpStatus>
      )}
      {!isTripRoot && (
        <HttpStatus code={404}>
          <Error404PageWithOffers />
        </HttpStatus>
      )}
    </>
  )
}

export default Trip404Page
